import { Form, Input, ModalProps, FormProps, Modal, InputNumber, useSelect, Select } from '@pankod/refine-antd'
import { useGetIdentity } from '@pankod/refine-core'
import { useUserContext } from 'context/user'
import { createUserHistory } from 'gql/mutations'
import { ICompetency } from 'interfaces'

type EditTNTaxonomyProps = {
  modalProps: ModalProps
  formProps: FormProps
}

export const EditTNTaxonomy: React.FC<EditTNTaxonomyProps> = ({ modalProps, formProps }) => {
  const { data: user } = useGetIdentity()

  const { selectProps: competenciesSelectProps } = useSelect<ICompetency>({
    resource: 'competencies',
    fetchSize: 1000,
    optionLabel: 'name',
    optionValue: 'id',
    metaData: {
      fields: ['id', 'name'],
    },
    filters:[
        {
          field: 'in_use',
          operator: 'eq',
          value: true,
        },
    ],
    sort: [{ field: 'name', order: 'asc' }],
    onSearch: value => [
      {
        field: 'name',
        operator: 'contains',
        value: `${value.toLowerCase()}%`,
      },
    ],
  })
  const { userRole } = useUserContext()
  const onFinish = async (values: any) => {
    return (
      formProps.onFinish &&
      formProps.onFinish({
        ...values,
        updated_by: user?.id

      })
    )
  }
  return (
    <Modal {...modalProps} title="Edit Taxonomy">
      <Form {...formProps} layout="vertical" onFinish={async values => {
        let response = await onFinish(values).then((response: any) => {
          if (response) {
            createUserHistory('tn_taxonomys', 'edit', response?.data?.id, user?.id, userRole)
          }

        })

        return response
      }}>
        <Form.Item
          label="Taxonomy Name"
          name="name"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          label="Competencies"
          name="competency_id"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select {...competenciesSelectProps} />
        </Form.Item>
        <Form.Item name="updated_by" initialValue={user?.id}>
          <Input type="hidden" />
        </Form.Item>
      </Form>
    </Modal>
  )
}
